import { SET_APP_CONFIGS, SetAppConfigsAction } from '../types'

const initialState = {}

const BudgetingConfigReducer = (state = initialState, action: SetAppConfigsAction) => {
  switch (action.type) {
    case SET_APP_CONFIGS:
      return action.payload.budgeting
    default:
      return state
  }
}

export default BudgetingConfigReducer
